const SvgBundle1 = (props) => (
  <>
    <circle cx={48} cy={72} r={24} fill={props.p40} />
    <circle cx={48} cy={24} r={24} fill={props.p40} />
  </>
);

export default SvgBundle1;
